import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { ref, computed, onMounted } from 'vue';
import Foot from './components/foot.vue';
import HeaderNav from '@/components/headerNav.vue';
import LoginToast from '@/components/loginToast.vue';
import Book from './components/release/book.vue';
import { useRouter } from 'vue-router';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const showLogin = ref(false);
const router = useRouter();
const key = computed(() => router.currentRoute.value.path + Date.now());
onMounted(() => {
  // if (window.localStorage.getItem('loginFlag') === '0') {
  //   showLogin.value = true;
  //   window.localStorage.setItem('loginFlag', '1');
  // }
  let top = document.documentElement.scrollTop || document.body.scrollTop;
  // 实现滚动效果
  const timeTop = setInterval(() => {
    document.body.scrollTop = document.documentElement.scrollTop = top -= 100;
    if (top <= 0) {
      clearInterval(timeTop);
    }
  }, 10);
});

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(HeaderNav),
    _createVNode(Book),
    (_openBlock(), _createBlock(_component_router_view, { key: _unref(key) })),
    _createVNode(Foot),
    _createVNode(LoginToast, {
      showLogin: showLogin.value,
      "onUpdate:confirm": _cache[0] || (_cache[0] = ($event: any) => (showLogin.value = false))
    }, null, 8, ["showLogin"])
  ], 64))
}
}

})